module.exports = __webpack_public_path__ + "img/Washi-tape-top-right.aa4c3b3f.svg";